(() => {

  const dashboard =
    document.querySelector(
      '[data-pnadm-dashboard]'
    );

  if (!dashboard) {
    return;
  }


  const get =
    selector =>
      dashboard.querySelector(
        selector
      );


  const fields = {

    totalUsers:
      get('[data-pnadm-total-users]'),

    pending:
      get('[data-pnadm-pending]'),

    approvedMentors:
      get('[data-pnadm-approved-mentors]'),

    visibleMentors:
      get('[data-pnadm-visible-mentors]'),

    funnelPending:
      get('[data-pnadm-funnel-pending]'),

    funnelReview:
      get('[data-pnadm-funnel-review]'),

    funnelApproved:
      get('[data-pnadm-funnel-approved]'),

    funnelRejected:
      get('[data-pnadm-funnel-rejected]'),

    students:
      get('[data-pnadm-students]'),

    mentors:
      get('[data-pnadm-mentors]'),

    admins:
      get('[data-pnadm-admins]'),

    suspended:
      get('[data-pnadm-suspended]')

  };


  const list =
    get(
      '[data-pnadm-application-list]'
    );

  const detail =
    get(
      '[data-pnadm-application-detail]'
    );

  const errorBox =
    get(
      '[data-pnadm-error]'
    );

  const tabs =
    [
      ...dashboard.querySelectorAll(
        '[data-pnadm-filter]'
      )
    ];


  let initialized = false;
  let applications = [];
  let activeFilter = 'pending';


  function escapeHTML(
    value
  ) {

    return String(
      value ?? ''
    )
      .replaceAll(
        '&',
        '&amp;'
      )
      .replaceAll(
        '<',
        '&lt;'
      )
      .replaceAll(
        '>',
        '&gt;'
      )
      .replaceAll(
        '"',
        '&quot;'
      )
      .replaceAll(
        "'",
        '&#039;'
      );

  }


  function setText(
    element,
    value
  ) {

    if (!element) {
      return;
    }


    element.textContent =
      String(
        value ?? 0
      );

  }


  function formatStatus(
    status
  ) {

    return String(
      status || ''
    )
      .replaceAll(
        '_',
        ' '
      )
      .replace(
        /\b\w/g,
        letter =>
          letter.toUpperCase()
      );

  }


  function formatDate(
    value
  ) {

    if (!value) {
      return '—';
    }


    const date =
      new Date(
        value
      );


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '—';
    }


    return date.toLocaleDateString(
      undefined,
      {
        day:'numeric',
        month:'short',
        year:'numeric'
      }
    );

  }


  function safeURL(
    value
  ) {

    try {

      const url =
        new URL(
          String(value || '')
        );


      if (
        ![
          'http:',
          'https:'
        ].includes(
          url.protocol
        )
      ) {
        return null;
      }


      return url.href;

    }

    catch (_) {

      return null;

    }

  }


  function renderStats(
    stats
  ) {

    setText(
      fields.totalUsers,
      stats.total_users
    );

    setText(
      fields.pending,
      stats.pending_applications
    );

    setText(
      fields.approvedMentors,
      stats.approved_mentors
    );

    setText(
      fields.visibleMentors,
      stats.visible_mentors
    );


    setText(
      fields.funnelPending,
      stats.pending_applications
    );

    setText(
      fields.funnelReview,
      stats.under_review_applications
    );

    setText(
      fields.funnelApproved,
      stats.approved_applications
    );

    setText(
      fields.funnelRejected,
      stats.rejected_applications
    );


    setText(
      fields.students,
      stats.student_users
    );

    setText(
      fields.mentors,
      stats.mentor_users
    );

    setText(
      fields.admins,
      stats.admin_users
    );

    setText(
      fields.suspended,
      stats.suspended_mentors
    );

  }


  function renderChips(
    values
  ) {

    if (
      !Array.isArray(values) ||
      !values.length
    ) {
      return `
        <span class="pn-status pn-status--info">
          None added
        </span>
      `;
    }


    return values
      .map(
        value => `
          <span class="pn-status pn-status--info">
            ${escapeHTML(value)}
          </span>
        `
      )
      .join('');

  }


  function renderApplications() {

    if (!applications.length) {

      list.innerHTML = `
        <div class="pnadm__detail-empty">
          <div>
            <strong>
              No ${escapeHTML(
                activeFilter
                  ? formatStatus(
                      activeFilter
                    ).toLowerCase()
                  : ''
              )} applications
            </strong>

            <p>
              New applications will appear here automatically.
            </p>
          </div>
        </div>
      `;


      detail.innerHTML = `
        <div class="pnadm__detail-empty">
          <div>
            <strong>
              Nothing to review
            </strong>

            <p>
              Select another application status.
            </p>
          </div>
        </div>
      `;

      return;

    }


    list.innerHTML =
      applications
        .map(
          application => `
            <button
              type="button"
              class="pnadm-app pn-dashboard-hover"
              data-pnadm-application="${escapeHTML(
                application.id
              )}"
            >

              <div>

                <strong>
                  ${escapeHTML(
                    application.applicant_name ||
                    'PeerNest applicant'
                  )}
                </strong>

                <small>
                  ${escapeHTML(
                    application.college_name_text ||
                    'College not provided'
                  )}
                  ·
                  ${escapeHTML(
                    application.program_name_text ||
                    'Program not provided'
                  )}
                </small>

              </div>


              <span
                class="pnadm__badge"
                data-status="${escapeHTML(
                  application.application_status
                )}"
              >
                ${escapeHTML(
                  formatStatus(
                    application.application_status
                  )
                )}
              </span>

            </button>
          `
        )
        .join('');


    list
      .querySelectorAll(
        '[data-pnadm-application]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            () => {

              selectApplication(
                button.dataset
                  .pnadmApplication
              );

            }
          );

        }
      );


    selectApplication(
      applications[0].id
    );

  }


  // Phone is saved in profiles.phone, NOT mentor_applications.
  // Only a verified Admin may fetch it through the secured Supabase RPC.
  async function loadApplicationPhone(applicationId) {
    const selected = String(applicationId);
    try {
      const result = await window.PeerNestDB.request(
        'rpc/pn_admin_get_application_phone_v1',
        '',
        {
          method: 'POST',
          body: { p_application_id: applicationId }
        }
      );
      // Ignore an older async result if the Admin selected another application.
      if (detail.dataset.pnadmSelectedApplication !== selected) return;
      const target = detail.querySelector('[data-pnadm-application-phone]');
      if (!target) return;
      const phone = String(result?.phone || '').trim();
      target.textContent = phone || 'Not provided';
    } catch (error) {
      if (detail.dataset.pnadmSelectedApplication !== selected) return;
      const target = detail.querySelector('[data-pnadm-application-phone]');
      if (target) target.textContent = 'Unable to load';
      console.warn('[PeerNest Admin] Applicant phone unavailable:', error);
    }
  }


  async function selectApplication(
    id
  ) {

    const application =
      applications.find(
        item =>
          item.id === id
      );


    if (!application) {
      return;
    }


    list
      .querySelectorAll(
        '[data-pnadm-application]'
      )
      .forEach(
        button => {

          button.classList.toggle(
            'is-active',
            button.dataset
              .pnadmApplication === id
          );

        }
      );


    const linkedin =
      safeURL(
        application.linkedin_url
      );


    const achievements =
      Array.isArray(
        application.achievements_text
      )
        ? application.achievements_text
        : [];


    const status =
      application.application_status;


    const canReview =
      [
        'pending',
        'under_review'
      ].includes(
        status
      );


    detail.innerHTML = `

      <div class="pnadm-review-detail">

        <div class="pnadm-review-detail__header">

          <div>

            <span class="pnadm__eyebrow">
              MENTOR APPLICATION
            </span>

            <h2>
              ${escapeHTML(
                application.applicant_name ||
                'PeerNest applicant'
              )}
            </h2>

            <p>
              ${escapeHTML(
                application.applicant_email ||
                ''
              )}
            </p>

            <p>
              <strong>Phone:</strong>
              <span data-pnadm-application-phone>Loading…</span>
            </p>

          </div>


          <span
            class="pnadm-review-status"
            data-status="${escapeHTML(status)}"
          >
            ${escapeHTML(
              formatStatus(status)
            )}
          </span>

        </div>


        <div class="pnadm-review-detail__metrics">

          <div>
            <span>COLLEGE</span>
            <strong>
              ${escapeHTML(
                application.college_name_text ||
                '—'
              )}
            </strong>
          </div>

          <div>
            <span>PROGRAM</span>
            <strong>
              ${escapeHTML(
                application.program_name_text ||
                '—'
              )}
            </strong>
          </div>

          <div>
            <span>GRADUATION</span>
            <strong>
              ${escapeHTML(
                application.graduation_year ||
                '—'
              )}
            </strong>
          </div>

          <div>
            <span>SUBMITTED</span>
            <strong>
              ${escapeHTML(
                formatDate(
                  application.created_at
                )
              )}
            </strong>
          </div>

        </div>


        <section class="pnadm-review-block">

          <span class="pnadm-review-block__label">
            EXPERTISE
          </span>

          <div class="pnadm-review-chips">
            ${renderChips(
              application.expertise_text
            )}
          </div>

        </section>


        <section class="pnadm-review-block">

          <span class="pnadm-review-block__label">
            LANGUAGES
          </span>

          <div class="pnadm-review-chips">
            ${renderChips(
              application.languages_text
            )}
          </div>

        </section>


        ${
          achievements.length
            ? `
              <section class="pnadm-review-block">

                <span class="pnadm-review-block__label">
                  ACHIEVEMENTS
                </span>

                <ul class="pnadm-review-list">
                  ${
                    achievements
                      .map(
                        item => `
                          <li>
                            ${escapeHTML(item)}
                          </li>
                        `
                      )
                      .join('')
                  }
                </ul>

              </section>
            `
            : ''
        }


        <section class="pnadm-review-block">

          <span class="pnadm-review-block__label">
            WHY THEY WANT TO MENTOR
          </span>

          <p class="pnadm-review-copy">
            ${escapeHTML(
              application.reason_for_mentoring ||
              '—'
            )}
          </p>

        </section>


        ${
          linkedin
            ? `
              <section class="pnadm-review-block">

                <span class="pnadm-review-block__label">
                  LINKEDIN
                </span>

                <a
                  class="pn-dashboard-secondary"
                  href="${escapeHTML(linkedin)}"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open LinkedIn ↗
                </a>

              </section>
            `
            : ''
        }


        <section class="pnadm-review-block">

          <span class="pnadm-review-block__label">
            VERIFICATION
          </span>

          <div
            class="pnadm-verification-grid"
            data-pnadm-verification
          >

            <div class="pnadm-verification-card">
              Loading applicant photo…
            </div>

            <div class="pnadm-verification-card">
              Loading college ID…
            </div>

          </div>

        </section>


        <section class="pnadm-review-block">

          <label class="pnadm-review-notes">

            <span class="pnadm-review-block__label">
              ADMIN NOTES
            </span>

            <textarea
              data-pnadm-admin-notes
              rows="4"
              placeholder="Internal notes about this application…"
              ${canReview ? '' : 'disabled'}
            >${escapeHTML(
              application.admin_notes ||
              ''
            )}</textarea>

          </label>

        </section>


        ${
          canReview
            ? `
              <div class="pnadm-review-actions">

                ${
                  status === 'pending'
                    ? `
                      <button
                        type="button"
                        class="pnadm-action pnadm-action--review"
                        data-pnadm-review-action="under_review"
                      >
                        Mark Under Review
                      </button>
                    `
                    : ''
                }

                <button
                  type="button"
                  class="pnadm-action pnadm-action--approve"
                  data-pnadm-review-action="approve"
                >
                  Approve Mentor
                </button>

                <button
                  type="button"
                  class="pnadm-action pnadm-action--reject"
                  data-pnadm-review-action="reject"
                >
                  Reject
                </button>

              </div>
            `
            : `
              <div class="pnadm-review-complete">
                Review completed
                ${
                  application.reviewed_at
                    ? ` · ${escapeHTML(
                        formatDate(
                          application.reviewed_at
                        )
                      )}`
                    : ''
                }
              </div>
            `
        }

      </div>
    `;


    detail.hidden =
      false;


    // Load contact details from the applicant's private profile through
    // an Admin-only RPC. Never trust or expose this on public mentor pages.
    detail.dataset.pnadmSelectedApplication = String(application.id);
    loadApplicationPhone(application.id);


    loadVerificationFiles(
      application
    );


    detail
      .querySelectorAll(
        '[data-pnadm-review-action]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            () => {

              runReviewAction(
                button.dataset
                  .pnadmReviewAction,

                application
              );

            }
          );

        }
      );

  }



  async function loadVerificationFiles(
    application
  ) {

    const container =
      detail.querySelector(
        '[data-pnadm-verification]'
      );


    if (!container) {
      return;
    }


    try {

      const [
        photoURL,
        documentURL
      ] =
        await Promise.all([

          window.PeerNestDB
            .adminGetMentorApplicationFileURL(
              'mentor-application-photos',
              application.photo_url
            ),

          window.PeerNestDB
            .adminGetMentorApplicationFileURL(
              'mentor-application-documents',
              application.college_id_document_url
            )

        ]);


      const safePhotoURL =
        safeURL(
          photoURL
        );


      const safeDocumentURL =
        safeURL(
          documentURL
        );


      const documentIsPDF =
        /\.pdf(?:$|\?)/i.test(
          application.college_id_document_url ||
          ''
        );


      container.innerHTML = `

        <div class="pnadm-verification-card">

          <span>
            APPLICANT PHOTO
          </span>

          ${
            safePhotoURL
              ? `
                <img
                  src="${escapeHTML(
                    safePhotoURL
                  )}"
                  alt="Mentor applicant verification photo"
                >
              `
              : `
                <strong>
                  Photo unavailable
                </strong>
              `
          }

        </div>


        <div class="pnadm-verification-card">

          <span>
            COLLEGE ID
          </span>

          ${
            safeDocumentURL
              ? documentIsPDF
                ? `
                  <a
                    class="pn-dashboard-secondary"
                    href="${escapeHTML(
                      safeDocumentURL
                    )}"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open college ID PDF ↗
                  </a>
                `
                : `
                  <a
                    href="${escapeHTML(
                      safeDocumentURL
                    )}"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="${escapeHTML(
                        safeDocumentURL
                      )}"
                      alt="College ID verification document"
                    >
                  </a>
                `
              : `
                <strong>
                  Document unavailable
                </strong>
              `
          }

        </div>

      `;

    }

    catch (error) {

      console.error(
        '[PeerNest] Verification preview:',
        error
      );


      container.innerHTML = `
        <div class="pnadm-verification-error">
          Verification files could not be loaded.
        </div>
      `;

    }

  }



  async function runReviewAction(
    action,
    application
  ) {

    const notes =
      detail
        .querySelector(
          '[data-pnadm-admin-notes]'
        )
        ?.value
        ?.trim() ||
      null;


    if (
      action === 'reject' &&
      !notes
    ) {

      errorBox.textContent =
        'Add an admin note explaining why this application is being rejected.';

      errorBox.hidden =
        false;

      return;

    }


    if (
      action === 'approve' &&
      !window.confirm(
        `Approve ${application.applicant_name || 'this applicant'} as a PeerNest mentor?`
      )
    ) {
      return;
    }


    if (
      action === 'reject' &&
      !window.confirm(
        `Reject ${application.applicant_name || 'this applicant'}?`
      )
    ) {
      return;
    }


    const buttons =
      [
        ...detail.querySelectorAll(
          '[data-pnadm-review-action]'
        )
      ];


    buttons.forEach(
      button => {
        button.disabled = true;
      }
    );


    errorBox.hidden =
      true;


    try {

      if (
        action === 'under_review'
      ) {

        await window.PeerNestDB
          .adminMarkMentorApplicationUnderReview(
            application.id
          );

      }


      if (
        action === 'approve'
      ) {

        await window.PeerNestDB
          .adminApproveMentorApplication(
            application.id,
            notes
          );

      }


      if (
        action === 'reject'
      ) {

        await window.PeerNestDB
          .adminRejectMentorApplication(
            application.id,
            notes
          );

      }


      const stats =
        await window.PeerNestDB
          .adminGetDashboardStats();


      renderStats(
        stats
      );


      await loadApplications(
        activeFilter
      );

    }

    catch (error) {

      console.error(
        '[PeerNest] Mentor review action:',
        error
      );


      errorBox.textContent =
        error?.message ||
        'The mentor application could not be updated.';


      errorBox.hidden =
        false;


      buttons.forEach(
        button => {
          button.disabled = false;
        }
      );

    }

  }



  async function loadApplications(
    status = 'pending'
  ) {

    activeFilter =
      status;


    tabs.forEach(
      tab => {

        tab.classList.toggle(
          'is-active',
          tab.dataset
            .pnadmFilter === status
        );

      }
    );


    list.innerHTML = `
      <div class="pnadm__detail-empty">
        <div>
          <strong>
            Loading applications…
          </strong>
        </div>
      </div>
    `;


    try {

      applications =
        await window.PeerNestDB
          .adminListMentorApplications(
            status || null
          );


      renderApplications();

    }

    catch (error) {

      console.error(
        '[PeerNest] Admin applications:',
        error
      );


      applications = [];


      errorBox.textContent =
        error?.message ||
        'Could not load mentor applications.';


      errorBox.hidden =
        false;

    }

  }


  async function loadDashboard() {

    if (initialized) {
      return;
    }


    initialized =
      true;


    errorBox.hidden =
      true;


    try {

      const stats =
        await window.PeerNestDB
          .adminGetDashboardStats();


      renderStats(
        stats
      );


      await loadApplications(
        'pending'
      );

    }

    catch (error) {

      console.error(
        '[PeerNest] Admin dashboard:',
        error
      );


      errorBox.textContent =
        error?.message ||
        'Could not load admin dashboard data.';


      errorBox.hidden =
        false;

    }

  }


  tabs.forEach(
    tab => {

      tab.addEventListener(
        'click',
        () => {

          loadApplications(
            tab.dataset
              .pnadmFilter || ''
          );

        }
      );

    }
  );


  document.addEventListener(
    'peernest:dashboard-ready',
    event => {

      if (
        event?.detail?.profile?.role ===
        'admin'
      ) {

        loadDashboard();

      }

    }
  );


  const content =
    dashboard.querySelector(
      '[data-pndash-content]'
    );


  if (
    content &&
    !content.hidden &&
    window.PeerNestDB
  ) {

    loadDashboard();

  }

})();
